export default __webpack_public_path__ + "static/media/p6.e5b42f75.png";